import IconSVG from 'svg-inline-react'

export function popUp({ path, onClose, onMessage, windowName, windowOptions }) {
  windowName = windowName || 'ConnectWithOAuth' // should not include space for IE
  windowOptions = windowOptions || 'location=0,status=0,width=800,height=650'
  onClose = onClose || function() {}
  const _oauthWindow = window.open(path, windowName, windowOptions)
  const _oauthInterval = window.setInterval(function() {
    if (_oauthWindow.closed) {
      window.clearInterval(_oauthInterval)
      onClose()
    }
  }, 1000)
  const eventer = window.addEventListener
  eventer('message', e => {
    if (e.origin !== window.location.origin || e.source !== _oauthWindow) return
    !!onMessage && onMessage(e)
  })
  return _oauthWindow
}

export function renderLogo(src) {
  return (
    <i className="logo">
      <img src={src} alt="logo" />
    </i>
  )
}

export function renderLogoSVG(src) {
  return (
    <i className="logo">
      <IconSVG src={src} />
    </i>
  )
}

export function createAppName(appName){
  return appName.toLowerCase().replace(/ /g, "-").replace(/\'/g,"")
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/helpers.js